import React, { Component } from 'react';
import '../styles/dvAnimateCss.style.scss';

class DvAnimateCss extends Component {
  getClassName = () => {
    const {type, delay, speed} = this.props;
    const animationDiv = this.refs.animationDiv;
    let className = '';

    if(typeof type !== 'undefined' && type.length > 0){
      className += 'animated '+type;
      
      if(typeof delay !== 'undefined' && delay > 0){
        className += ' delay-'+delay+'s';
      }

      if(typeof speed !== 'undefined' && speed.length > 0){
        className += ' '+speed;
      }
      
    }

    if(className !== '' && typeof animationDiv !== 'undefined'){
      animationDiv.addEventListener("webkitAnimationEnd", this.animationEndEvent);
      animationDiv.addEventListener("animationend", this.animationEndEvent);
    }

    return className;
  }

  animationEndEvent = () => {
    const {onAnimationEnd} = this.props;
    const animationDiv = this.refs.animationDiv;

    if(typeof onAnimationEnd !== 'undefined'){
      onAnimationEnd();
    }

    animationDiv.removeEventListener("webkitAnimationEnd", this.animationEndEvent);
    animationDiv.removeEventListener("animationend", this.animationEndEvent);
  }

  render() {
    const className = this.getClassName();

    return (
      <div className={className} ref="animationDiv">
        {this.props.children}
      </div>
    );
  }
}

export default DvAnimateCss;
